(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@scuf/common"), require("@scuf/localization"), require("react-day-picker"));
	else if(typeof define === 'function' && define.amd)
		define("@bmsp/bmsp.web.component.common", ["react", "@scuf/common", "@scuf/localization", "react-day-picker"], factory);
	else if(typeof exports === 'object')
		exports["@bmsp/bmsp.web.component.common"] = factory(require("react"), require("@scuf/common"), require("@scuf/localization"), require("react-day-picker"));
	else
		root["@bmsp/bmsp.web.component.common"] = factory(root["react"], root["@scuf/common"], root["@scuf/localization"], root["react-day-picker"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__9297__, __WEBPACK_EXTERNAL_MODULE__5878__, __WEBPACK_EXTERNAL_MODULE__133__, __WEBPACK_EXTERNAL_MODULE__3034__) {
return 